import { useContext } from "react";
import { useQuery } from "react-query";

import { AppContext } from "contexts";
import {
  makeSimpleDeleteRequest,
  makeSimpleGetRequest,
  makeSimplePostRequest,
} from "lib/axios";
import { getBaseURL } from "lib/helpers";
import { ListingWithIncludes } from "services/listings/types";

import { Proxy, ProxyPayload } from "./types";

const BASE_SERVER_URL = getBaseURL();
export const orderBookApi = `${BASE_SERVER_URL}/orderbook/api`;
const BASE_PROXY_URL = `${BASE_SERVER_URL}/orderbook/api/proxies/`;

export const getUseProxiesQueryKey = (listingId: number) =>
  `proxies-${listingId}`;
export const useProxies = (listing: ListingWithIncludes | undefined) => {
  const appContext = useContext(AppContext);
  const isUserAuthenticated = !!appContext.user;
  return useQuery(
    getUseProxiesQueryKey(listing?.id),
    async () =>
      await makeSimpleGetRequest<Proxy[]>(
        `${BASE_PROXY_URL}?filter{listing}=${listing?.id}`,
      ),
    {
      enabled: isUserAuthenticated && !!listing && !listing.is_owner,
      staleTime: Infinity,
    },
  );
};

export const createProxy = (payload: ProxyPayload): Promise<Proxy> =>
  makeSimplePostRequest<Proxy>(
    `${BASE_PROXY_URL}`,
    JSON.stringify(payload),
    [201],
    undefined,
  );

export const deleteProxy = (id: number): Promise<void> =>
  makeSimpleDeleteRequest<void>(`${BASE_PROXY_URL}${id}/`, [204], undefined);
